import { t } from 'i18next';

import { ErrorResponseErrorItemCodeTag } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeTag, string> => ({
  'tag:tags_not_found': t('tag.tagsNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Taggar existerar inte.',
  }),
});
